import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { startEntityAdding } from '../../../../entityManagement/actions';
import EntityManager from '../../../../entityManagement/components/EntityManager';
import ResourceAddForm from './ResourceAddForm';
import ResourceEditForm from './ResourceEditForm';
import ResourcesTable from './ResourcesTable';
import ResourceDeleteDialog from './ResourceDeleteDialog';

const ResourcesManager = EntityManager({
    Title: <LocalizedText textKey={TextKey.Resources} />,
    Table: ResourcesTable,
    AddForm: ResourceAddForm,
    EditForm: ResourceEditForm,
    DeleteDialog: ResourceDeleteDialog,
});

// @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
export default connect(undefined, (dispatch, { scope }) => ({
    onAdd: () => dispatch(startEntityAdding(scope)),
}))(ResourcesManager);
